var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import dayjs from "dayjs";
import { t } from "i18next";
import { UploadImage } from "../../../api/api";
import { Config } from "../../../api/config";
import { assignBayListAPI, ByCoverageTypeUrl, deleteAllJobCardAttachmentsUrl, floorSupervisorListAPI, futureAdviceGetURL, futureAdviceUpsertURL, GetCompaignList, getDefectListUrl, getFinalInspectorListUrl, getInsuranceProviderListUrl, getJobCardValidateQuantityAndGetTaxUrl, getLossTypeListUrl, getPartListAPIUrl, getPriceWithTaxUrl, getServiceTypeListUrl, getSupplierListUrl, getTaxUrl, getUnitOfMeasurementListUrl, getWorkDistributionListUrl, getWorkDistributionStatusListUrl, getWorkPurchaseOrderListUrl, JCCustomerVoicesURL, jobCardAttachmentCreateUrl, jobCardGetDetailAPI, LanguageListAPI, NatureOfAccidentListUrl, serviceAdvisorListAPI, technicianListAPI, upsertAccidentAndInsuranceDetaisUrl, upsertSuggestionsURL, upsertWorkDistributionUrl, VIContactPreferencePickListAPI } from "../../../api/url";
import { getLoadingKey } from "../../../builderPackage/common/commonFunctions";
import { LOCAL_STORAGE_KEYS, StatusEnum } from "../../../constants";
import { showLoader, showNotification } from "../../../redux/commonSlice";
import { createAPI, deleteAPI, getByIdAPI, getListAPI, setReducerState, updateAPI } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { complaintSubCategoryURL, complaintTypeGetComplaintsURL, customerVoiceCVTypeListURL, customerVoiceFromListURL, deleteLabourAPI, getConfigurationsAPI, getLabourbyJobCard, GetOrganizationTypeListURL, getPartsbyJobCard, getWarrantyListByJobCardId, JobCardDetailsURL, JobCardKeys, LabourListURL, modifyJobCardURL, pauseReasonListAPIUrl, reworkHistoryAPI, updateJobCardLabourStatusAPI, UpdateLabourListAPI, upsertCustomerVoiceURL, upsertWarrantyDetailsURL, ValidateDeletePartLabourUrl, warrantyCasualFlagListURL, warrantyComplaintTypeGetComplaintsURL, warrantyGetPartDetailsURL, warrantyServiceTypeListURL, WorkPurchaseOrderListURL } from "./entity";
var dispatch = store.dispatch;
export var getJobCardById = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "documentDetailsGetById" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? jobCardGetDetailAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
export var languageList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload2, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? '' : _a, _b = params.request, request = _b === void 0 ? {
                    OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                } : _b, _c = params.url, url = _c === void 0 ? LanguageListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
        }
    });
}); };
export var contactList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload3, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? '' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? VIContactPreferencePickListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
        }
    });
}); };
export var getPartsDetails = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload4, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.Parts : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getPartsbyJobCard : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.value];
        }
    });
}); };
export var getLabourDetails = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.Labour : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getLabourbyJobCard : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.value];
        }
    });
}); };
export var reworkHistoryApiCall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$data, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.ReworkHistory : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? reworkHistoryAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.value];
        }
    });
}); };
export var configurationAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$data2, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.Configurations : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getConfigurationsAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.value];
        }
    });
}); };
export var updateJobCardLabourStatusAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$data3, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.UpdateJobCardLabourStatus : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? updateJobCardLabourStatusAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.value];
        }
    });
}); };
export var updateJobCardLaboursAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$data4, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.UpdateJobCardLabourStatus : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? UpdateLabourListAPI : _c;
                return [4 /*yield*/, dispatch(updateAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.value];
        }
    });
}); };
export var deleteLabourAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$data5, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.DeleteLabour : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? deleteLabourAPI : _c;
                return [4 /*yield*/, dispatch(deleteAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.value];
        }
    });
}); };
export var getCustomerVoiceAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$data6, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.CustomerVoice : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? JCCustomerVoicesURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.value];
        }
    });
}); };
export var getTechnicianList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _getLocalStorageItem, _res$payload6, _a, key, _b, request, _c, url, state, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'technicianList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? technicianListAPI : _c, state = params.state;
                request.WorkingOrganizationId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.value];
        }
    });
}); };
export var getCampaignList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload7, _a, key, _b, request, _c, url, state, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'campaignList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? GetCompaignList : _c, state = params.state;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: _objectSpread(_objectSpread({}, request), {}, {
                            ProductId: state === null || state === void 0 ? void 0 : state.ProductId,
                            ParentOrganizationId: state === null || state === void 0 ? void 0 : state.ParentOrganizationId,
                            ServiceTypeId: state === null || state === void 0 ? void 0 : state.RepairTypeId,
                            DocumentDate: (state === null || state === void 0 ? void 0 : state.CreatedOn) || new Date().toISOString()
                        })
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.value];
        }
    });
}); };
export var getServiceAdvisorAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload8, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'serviceAdvisorList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? serviceAdvisorListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value];
        }
    });
}); };
export var assignBayListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload9, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'assignBayList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? assignBayListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.value];
        }
    });
}); };
export var floorSupervisorListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload10, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'floorSupervisor' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? floorSupervisorListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload10 = res.payload) === null || _res$payload10 === void 0 ? void 0 : _res$payload10.value];
        }
    });
}); };
export var getFinalInspectorListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload11, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'getFinalInspectorList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getFinalInspectorListUrl : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.value];
        }
    });
}); };
export var getNatureOfAccidentList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload12, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.NatureOfAccidentList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? NatureOfAccidentListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload12 = res.payload) === null || _res$payload12 === void 0 ? void 0 : _res$payload12.value];
        }
    });
}); };
export var getInsuranceProviderList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _getLocalStorageItem2, _getLocalStorageItem3, _res$payload13, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.InsuranceProviderList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getInsuranceProviderListUrl : _c;
                request.OrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.OrganizationId;
                request.ParentOrganizationId = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.ParentOrganizationId;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.value];
        }
    });
}); };
export var getCoverageTypeList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _params$state, _res$payload14, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.CoverageTypeList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ByCoverageTypeUrl : _c;
                request.InsuranceProviderId = params === null || params === void 0 || (_params$state = params.state) === null || _params$state === void 0 ? void 0 : _params$state.InsuranceProviderId;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload14 = res.payload) === null || _res$payload14 === void 0 ? void 0 : _res$payload14.value];
        }
    });
}); };
export var getLossTypeList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload15, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.CoverageTypeList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getLossTypeListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload15 = res.payload) === null || _res$payload15 === void 0 ? void 0 : _res$payload15.value];
        }
    });
}); };
export var getWorkDistributionList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload16, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.WorkDistributionList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getWorkDistributionListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                // return res?.payload?.value
                return [2 /*return*/, {
                        success: true,
                        data: {
                            WorkDistributions: res === null || res === void 0 || (_res$payload16 = res.payload) === null || _res$payload16 === void 0 || (_res$payload16 = _res$payload16.value) === null || _res$payload16 === void 0 ? void 0 : _res$payload16.data
                        }
                    }];
        }
    });
}); };
export var UpsertWorkDistribution = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload17, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.UpsertWorkDistributionKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? upsertWorkDistributionUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                // return res?.payload?.value
                return [2 /*return*/, {
                        success: true,
                        data: {
                            WorkDistributions: res === null || res === void 0 || (_res$payload17 = res.payload) === null || _res$payload17 === void 0 || (_res$payload17 = _res$payload17.value) === null || _res$payload17 === void 0 ? void 0 : _res$payload17.data
                        }
                    }];
        }
    });
}); };
export var getWorkDistributionStatusList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload18, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.LabourStatusList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getWorkDistributionStatusListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload18 = res.payload) === null || _res$payload18 === void 0 ? void 0 : _res$payload18.value];
        }
    });
}); };
export var getSupplierList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload19, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.SupplierList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getSupplierListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload19 = res.payload) === null || _res$payload19 === void 0 ? void 0 : _res$payload19.value];
        }
    });
}); };
export var getWorkPurchaseOrderList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload20, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.WorkPurchaseOrderList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getWorkPurchaseOrderListUrl : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload20 = res.payload) === null || _res$payload20 === void 0 ? void 0 : _res$payload20.value];
        }
    });
}); };
export var UnitOfMeasurementList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload21, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "UnitOfMeasurementList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getUnitOfMeasurementListUrl : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload21 = res.payload) === null || _res$payload21 === void 0 ? void 0 : _res$payload21.value];
        }
    });
}); };
export var getDefectList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload22, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.DefectList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getDefectListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload22 = res.payload) === null || _res$payload22 === void 0 ? void 0 : _res$payload22.value];
        }
    });
}); };
export var getPartList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload23, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'partList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getPartListAPIUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload23 = res.payload) === null || _res$payload23 === void 0 ? void 0 : _res$payload23.value];
        }
    });
}); };
export var getServiceTypeList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload24, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'serviceTypeList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getServiceTypeListUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload24 = res.payload) === null || _res$payload24 === void 0 ? void 0 : _res$payload24.value];
        }
    });
}); };
export var CustomerVoiceCVTypeListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload25, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'customerVoiceCVTypeList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? customerVoiceCVTypeListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload25 = res.payload) === null || _res$payload25 === void 0 ? void 0 : _res$payload25.value];
        }
    });
}); };
export var CustomerVoiceFromListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload26, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'customerVoiceFromList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? customerVoiceFromListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload26 = res.payload) === null || _res$payload26 === void 0 ? void 0 : _res$payload26.value];
        }
    });
}); };
export var complaintTypeGetComplaintAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload27, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'complaintTypeGetComplaints' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? complaintTypeGetComplaintsURL : _c;
                request.Name = 'Customer Complaint';
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload27 = res.payload) === null || _res$payload27 === void 0 ? void 0 : _res$payload27.value];
        }
    });
}); };
export var complaintTypeObservationAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload28, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'ObservationList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? complaintTypeGetComplaintsURL : _c;
                request.Name = 'Complaints';
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload28 = res.payload) === null || _res$payload28 === void 0 ? void 0 : _res$payload28.value];
        }
    });
}); };
export var complaintTypeActionTakenAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload29, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'actionTakenList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? complaintTypeGetComplaintsURL : _c;
                request.Name = 'Fault Code';
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload29 = res.payload) === null || _res$payload29 === void 0 ? void 0 : _res$payload29.value];
        }
    });
}); };
export var complaintSubCategoryAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload30, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'subCategory' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? complaintSubCategoryURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload30 = res.payload) === null || _res$payload30 === void 0 ? void 0 : _res$payload30.value];
        }
    });
}); };
var formatPartLabourGridData = function (data, SystemName, JCdata) {
    var updatedPartsOrLabours = data === null || data === void 0 ? void 0 : data.map(function (item) {
        var _item$PriceWithTax, _item$PriceWithTax2, _item$PriceWithTax3, _item$SavedPriceWithT, _item$SavedPriceWithT2, _item$SavedPriceWithT3, _item$PriceWithTaxLis9, _item$SavedPriceWithT4, _item$SavedPriceWithT5, _item$PriceWithTaxLis10, _item$SavedPriceWithT6, _item$SavedPriceWithT7, _item$SavedPriceWithT8, _item$SavedPriceWithT9, _item$SavedPriceWithT10, _item$SavedPriceWithT11, _item$PriceWithTaxLis11, _item$SavedPriceWithT12, _item$SavedPriceWithT13, _item$PriceWithTaxLis12, _item$SavedPriceWithT14, _item$SavedPriceWithT15, _item$PriceWithTaxLis13, _item$SavedPriceWithT16, _item$PriceWithTaxLis14, _item$SavedPriceWithT17, _item$PriceWithTaxLis15, _item$SavedPriceWithT18, _item$PriceWithTaxLis16;
        var IGST = (_item$PriceWithTax = item.PriceWithTax) === null || _item$PriceWithTax === void 0 || (_item$PriceWithTax = _item$PriceWithTax[0]) === null || _item$PriceWithTax === void 0 || (_item$PriceWithTax = _item$PriceWithTax.Taxes) === null || _item$PriceWithTax === void 0 ? void 0 : _item$PriceWithTax.find(function (item) { return item.TaxComponentName === "IGST"; });
        var CGST = (_item$PriceWithTax2 = item.PriceWithTax) === null || _item$PriceWithTax2 === void 0 || (_item$PriceWithTax2 = _item$PriceWithTax2[0]) === null || _item$PriceWithTax2 === void 0 || (_item$PriceWithTax2 = _item$PriceWithTax2.Taxes) === null || _item$PriceWithTax2 === void 0 ? void 0 : _item$PriceWithTax2.find(function (item) { return item.TaxComponentName === "CGST"; });
        var SGST = (_item$PriceWithTax3 = item.PriceWithTax) === null || _item$PriceWithTax3 === void 0 || (_item$PriceWithTax3 = _item$PriceWithTax3[0]) === null || _item$PriceWithTax3 === void 0 || (_item$PriceWithTax3 = _item$PriceWithTax3.Taxes) === null || _item$PriceWithTax3 === void 0 ? void 0 : _item$PriceWithTax3.find(function (item) { return item.TaxComponentName === "SGST"; });
        // const CGSTAmount = item?.CGSTAmount ? item?.CGSTAmount : CGST?.TaxComponentAmount
        // const SGST_UTGST_Amount = item?.SGST_UTGST_Amount ? item?.SGST_UTGST_Amount : SGST?.TaxComponentAmount
        // const IGSTAmount = item?.IGSTAmount ? item?.IGSTAmount : IGST?.TaxComponentAmount
        var UpdatedMinPrice = null;
        if (item !== null && item !== void 0 && (_item$SavedPriceWithT = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT !== void 0 && _item$SavedPriceWithT.PriceGroupCategoryId) {
            UpdatedMinPrice = item !== null && item !== void 0 && item.MinPrice ? item === null || item === void 0 ? void 0 : item.MinPrice : item === null || item === void 0 ? void 0 : item.MinLimit;
        }
        else {
            var _item$PriceWithTaxLis, _item$PriceWithTaxLis2;
            if (((_item$PriceWithTaxLis = item.PriceWithTaxList) === null || _item$PriceWithTaxLis === void 0 || (_item$PriceWithTaxLis = _item$PriceWithTaxLis[0]) === null || _item$PriceWithTaxLis === void 0 ? void 0 : _item$PriceWithTaxLis.MinPrice) !== null && ((_item$PriceWithTaxLis2 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis2 === void 0 || (_item$PriceWithTaxLis2 = _item$PriceWithTaxLis2[0]) === null || _item$PriceWithTaxLis2 === void 0 ? void 0 : _item$PriceWithTaxLis2.MinPrice) !== undefined) {
                var _item$PriceWithTaxLis3;
                UpdatedMinPrice = item === null || item === void 0 || (_item$PriceWithTaxLis3 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis3 === void 0 || (_item$PriceWithTaxLis3 = _item$PriceWithTaxLis3[0]) === null || _item$PriceWithTaxLis3 === void 0 ? void 0 : _item$PriceWithTaxLis3.MinPrice;
            }
            else {
                var _item$PriceWithTaxLis4;
                UpdatedMinPrice = item === null || item === void 0 || (_item$PriceWithTaxLis4 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis4 === void 0 || (_item$PriceWithTaxLis4 = _item$PriceWithTaxLis4[0]) === null || _item$PriceWithTaxLis4 === void 0 ? void 0 : _item$PriceWithTaxLis4.MinLimit;
            }
        }
        var updatedMaxPrice = null;
        if (item !== null && item !== void 0 && (_item$SavedPriceWithT2 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT2 !== void 0 && _item$SavedPriceWithT2.PriceGroupCategoryId) {
            updatedMaxPrice = item.MaxPrice ? item.MaxPrice : item.MaxLimit;
        }
        else {
            var _item$PriceWithTaxLis5, _item$PriceWithTaxLis6;
            if (((_item$PriceWithTaxLis5 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis5 === void 0 || (_item$PriceWithTaxLis5 = _item$PriceWithTaxLis5[0]) === null || _item$PriceWithTaxLis5 === void 0 ? void 0 : _item$PriceWithTaxLis5.MaxPrice) !== null && ((_item$PriceWithTaxLis6 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis6 === void 0 || (_item$PriceWithTaxLis6 = _item$PriceWithTaxLis6[0]) === null || _item$PriceWithTaxLis6 === void 0 ? void 0 : _item$PriceWithTaxLis6.MaxPrice) !== undefined) {
                var _item$PriceWithTaxLis7;
                updatedMaxPrice = (_item$PriceWithTaxLis7 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis7 === void 0 || (_item$PriceWithTaxLis7 = _item$PriceWithTaxLis7[0]) === null || _item$PriceWithTaxLis7 === void 0 ? void 0 : _item$PriceWithTaxLis7.MaxPrice;
            }
            else {
                var _item$PriceWithTaxLis8;
                updatedMaxPrice = (_item$PriceWithTaxLis8 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis8 === void 0 || (_item$PriceWithTaxLis8 = _item$PriceWithTaxLis8[0]) === null || _item$PriceWithTaxLis8 === void 0 ? void 0 : _item$PriceWithTaxLis8.MaxLimit;
            }
        }
        return _objectSpread(_objectSpread({}, item), {}, {
            SystemName: SystemName,
            SavedPriceWithTax: (_item$SavedPriceWithT3 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT3 !== void 0 && _item$SavedPriceWithT3.PriceGroupCategoryId ? item.SavedPriceWithTax : (_item$PriceWithTaxLis9 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis9 === void 0 ? void 0 : _item$PriceWithTaxLis9[0],
            MRP: (_item$SavedPriceWithT4 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT4 !== void 0 && _item$SavedPriceWithT4.PriceGroupCategoryId ? (_item$SavedPriceWithT5 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT5 === void 0 ? void 0 : _item$SavedPriceWithT5.MRP : (_item$PriceWithTaxLis10 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis10 === void 0 || (_item$PriceWithTaxLis10 = _item$PriceWithTaxLis10[0]) === null || _item$PriceWithTaxLis10 === void 0 ? void 0 : _item$PriceWithTaxLis10.MRP,
            EffectiveFromDate: (_item$SavedPriceWithT6 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT6 !== void 0 && _item$SavedPriceWithT6.EffectiveFromDate ? (_item$SavedPriceWithT7 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT7 === void 0 ? void 0 : _item$SavedPriceWithT7.EffectiveFromDate : "",
            EffectiveToDate: (_item$SavedPriceWithT8 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT8 !== void 0 && _item$SavedPriceWithT8.EffectiveToDate ? (_item$SavedPriceWithT9 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT9 === void 0 ? void 0 : _item$SavedPriceWithT9.EffectiveToDate : "",
            Rate: (_item$SavedPriceWithT10 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT10 !== void 0 && _item$SavedPriceWithT10.PriceGroupCategoryId ? (_item$SavedPriceWithT11 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT11 === void 0 ? void 0 : _item$SavedPriceWithT11.Rate : (_item$PriceWithTaxLis11 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis11 === void 0 || (_item$PriceWithTaxLis11 = _item$PriceWithTaxLis11[0]) === null || _item$PriceWithTaxLis11 === void 0 ? void 0 : _item$PriceWithTaxLis11.Rate,
            TaxableAmount: item !== null && item !== void 0 && (_item$SavedPriceWithT12 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT12 !== void 0 && _item$SavedPriceWithT12.PriceGroupCategoryId ? item === null || item === void 0 || (_item$SavedPriceWithT13 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT13 === void 0 ? void 0 : _item$SavedPriceWithT13.TaxableAmount : (_item$PriceWithTaxLis12 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis12 === void 0 || (_item$PriceWithTaxLis12 = _item$PriceWithTaxLis12[0]) === null || _item$PriceWithTaxLis12 === void 0 ? void 0 : _item$PriceWithTaxLis12.TaxableAmount,
            Amount: item !== null && item !== void 0 && (_item$SavedPriceWithT14 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT14 !== void 0 && _item$SavedPriceWithT14.PriceGroupCategoryId ? item === null || item === void 0 || (_item$SavedPriceWithT15 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT15 === void 0 ? void 0 : _item$SavedPriceWithT15.Amount : (_item$PriceWithTaxLis13 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis13 === void 0 || (_item$PriceWithTaxLis13 = _item$PriceWithTaxLis13[0]) === null || _item$PriceWithTaxLis13 === void 0 ? void 0 : _item$PriceWithTaxLis13.Amount,
            IsAllowForEdit: item !== null && item !== void 0 && (_item$SavedPriceWithT16 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT16 !== void 0 && _item$SavedPriceWithT16.PriceGroupCategoryId ? item.IsAllowForEdit : (_item$PriceWithTaxLis14 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis14 === void 0 || (_item$PriceWithTaxLis14 = _item$PriceWithTaxLis14[0]) === null || _item$PriceWithTaxLis14 === void 0 ? void 0 : _item$PriceWithTaxLis14.IsAllowForEdit,
            EditableRange: item !== null && item !== void 0 && (_item$SavedPriceWithT17 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT17 !== void 0 && _item$SavedPriceWithT17.PriceGroupCategoryId ? item.EditableRange : (_item$PriceWithTaxLis15 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis15 === void 0 || (_item$PriceWithTaxLis15 = _item$PriceWithTaxLis15[0]) === null || _item$PriceWithTaxLis15 === void 0 ? void 0 : _item$PriceWithTaxLis15.EditableRange,
            MaxPrice: updatedMaxPrice,
            MinPrice: UpdatedMinPrice,
            OriginalPrice: item !== null && item !== void 0 && (_item$SavedPriceWithT18 = item.SavedPriceWithTax) !== null && _item$SavedPriceWithT18 !== void 0 && _item$SavedPriceWithT18.PriceGroupCategoryId ? item.OriginalPrice : (_item$PriceWithTaxLis16 = item.PriceWithTaxList) === null || _item$PriceWithTaxLis16 === void 0 || (_item$PriceWithTaxLis16 = _item$PriceWithTaxLis16[0]) === null || _item$PriceWithTaxLis16 === void 0 ? void 0 : _item$PriceWithTaxLis16.OriginalPrice,
            IsPriceUpdate: item.IsPriceUpdate,
            DecimalPrecision: item.DecimalPrecision || 0,
            JCCreationDate: JCdata === null || JCdata === void 0 ? void 0 : JCdata.CreatedOn
            // SGST_UTGST_Amount: SGST_UTGST_Amount,
            // SGST_UTGST_Percentage: item?.SGST_UTGST_Percentage ? item?.SGST_UTGST_Percentage : SGST?.TaxComponentPercentage,
            // CGSTAmount: CGSTAmount,
            // CGSTPercentage: item?.CGSTPercentage ? item?.CGSTPercentage : CGST?.TaxComponentPercentage,
            // IGSTAmount: IGSTAmount,
            // IGSTPercentage: item?.IGSTPercentage ? item?.IGSTPercentage : IGST?.TaxComponentPercentage,
            // PriceGroupCategoryKey: item?.PriceGroupCategoryKey,
            // TotalTaxes: (SGST_UTGST_Amount || 0) + (CGSTAmount || 0) + (IGSTAmount || 0)
        });
    });
    return updatedPartsOrLabours || [];
};
export var getAllJobCardDetailsAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _jobCardDetails$paylo, _jobCardDetails$paylo2, _customerComplaint$pa, _jobCardDetails$paylo3, _jobCardDetails$paylo4, _partDetails$payload, _labourDetails$payloa, _jobCardDetails$paylo5, _warrantyList$payload, _labourStatusList$pay, _jobCardDetails$paylo6, _data$CustomerComplai, _a, key, _b, request, _c, url, loaderKey, _d, jobCardDetails, customerComplaint, partDetails, labourDetails, warrantyList, labourStatusList, ReadyForInvoice, data, res;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardKeys.Get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? JobCardDetailsURL(request.JobCardId) : _c;
                loaderKey = getLoadingKey(key);
                dispatch(setReducerState({
                    key: loaderKey,
                    value: 'loading'
                }));
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                            key: 'documentDetailsGetById',
                            url: url
                        })), dispatch(getListAPI({
                            key: JobCardKeys.CustomerVoice,
                            url: JCCustomerVoicesURL,
                            request: request
                        })), dispatch(getListAPI({
                            key: JobCardKeys.Parts,
                            url: getPartsbyJobCard,
                            request: request
                        })), dispatch(getByIdAPI({
                            key: JobCardKeys.Labour,
                            url: getLabourbyJobCard,
                            request: request
                        })), dispatch(getListAPI({
                            key: JobCardKeys.WarrantyGet,
                            url: getWarrantyListByJobCardId,
                            request: request
                        })), dispatch(getListAPI({
                            key: JobCardKeys.LabourStatusList,
                            url: getWorkDistributionStatusListUrl,
                            request: {
                                SystemName: "JobCardDetail"
                            }
                        }))])];
            case 1:
                _d = _e.sent(), jobCardDetails = _d[0], customerComplaint = _d[1], partDetails = _d[2], labourDetails = _d[3], warrantyList = _d[4], labourStatusList = _d[5];
                ReadyForInvoice = (jobCardDetails === null || jobCardDetails === void 0 || (_jobCardDetails$paylo = jobCardDetails.payload) === null || _jobCardDetails$paylo === void 0 || (_jobCardDetails$paylo = _jobCardDetails$paylo.value) === null || _jobCardDetails$paylo === void 0 || (_jobCardDetails$paylo = _jobCardDetails$paylo.data) === null || _jobCardDetails$paylo === void 0 ? void 0 : _jobCardDetails$paylo.Key) === StatusEnum.ReadyForInvoice;
                data = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, jobCardDetails === null || jobCardDetails === void 0 || (_jobCardDetails$paylo2 = jobCardDetails.payload) === null || _jobCardDetails$paylo2 === void 0 || (_jobCardDetails$paylo2 = _jobCardDetails$paylo2.value) === null || _jobCardDetails$paylo2 === void 0 ? void 0 : _jobCardDetails$paylo2.data), {}, {
                    ReadyForInvoice: ReadyForInvoice
                }, customerComplaint === null || customerComplaint === void 0 || (_customerComplaint$pa = customerComplaint.payload) === null || _customerComplaint$pa === void 0 || (_customerComplaint$pa = _customerComplaint$pa.value) === null || _customerComplaint$pa === void 0 ? void 0 : _customerComplaint$pa.data), jobCardDetails === null || jobCardDetails === void 0 || (_jobCardDetails$paylo3 = jobCardDetails.payload) === null || _jobCardDetails$paylo3 === void 0 || (_jobCardDetails$paylo3 = _jobCardDetails$paylo3.value) === null || _jobCardDetails$paylo3 === void 0 || (_jobCardDetails$paylo3 = _jobCardDetails$paylo3.data) === null || _jobCardDetails$paylo3 === void 0 ? void 0 : _jobCardDetails$paylo3.JobCardAccidentalDetail), jobCardDetails === null || jobCardDetails === void 0 || (_jobCardDetails$paylo4 = jobCardDetails.payload) === null || _jobCardDetails$paylo4 === void 0 || (_jobCardDetails$paylo4 = _jobCardDetails$paylo4.value) === null || _jobCardDetails$paylo4 === void 0 || (_jobCardDetails$paylo4 = _jobCardDetails$paylo4.data) === null || _jobCardDetails$paylo4 === void 0 ? void 0 : _jobCardDetails$paylo4.JobCardInsuranceDetail), {}, {
                    partDetails: formatPartLabourGridData(partDetails === null || partDetails === void 0 || (_partDetails$payload = partDetails.payload) === null || _partDetails$payload === void 0 || (_partDetails$payload = _partDetails$payload.value) === null || _partDetails$payload === void 0 ? void 0 : _partDetails$payload.data, "Parts"),
                    labourDetails: formatPartLabourGridData(labourDetails === null || labourDetails === void 0 || (_labourDetails$payloa = labourDetails.payload) === null || _labourDetails$payloa === void 0 || (_labourDetails$payloa = _labourDetails$payloa.value) === null || _labourDetails$payloa === void 0 ? void 0 : _labourDetails$payloa.data, "Service", jobCardDetails === null || jobCardDetails === void 0 || (_jobCardDetails$paylo5 = jobCardDetails.payload) === null || _jobCardDetails$paylo5 === void 0 || (_jobCardDetails$paylo5 = _jobCardDetails$paylo5.value) === null || _jobCardDetails$paylo5 === void 0 ? void 0 : _jobCardDetails$paylo5.data),
                    warrantyList: warrantyList === null || warrantyList === void 0 || (_warrantyList$payload = warrantyList.payload) === null || _warrantyList$payload === void 0 || (_warrantyList$payload = _warrantyList$payload.value) === null || _warrantyList$payload === void 0 ? void 0 : _warrantyList$payload.data,
                    labourStatusList: labourStatusList === null || labourStatusList === void 0 || (_labourStatusList$pay = labourStatusList.payload) === null || _labourStatusList$pay === void 0 || (_labourStatusList$pay = _labourStatusList$pay.value) === null || _labourStatusList$pay === void 0 ? void 0 : _labourStatusList$pay.data,
                    IsTechnicianAssigned: !!(jobCardDetails !== null && jobCardDetails !== void 0 && (_jobCardDetails$paylo6 = jobCardDetails.payload) !== null && _jobCardDetails$paylo6 !== void 0 && (_jobCardDetails$paylo6 = _jobCardDetails$paylo6.value) !== null && _jobCardDetails$paylo6 !== void 0 && (_jobCardDetails$paylo6 = _jobCardDetails$paylo6.data) !== null && _jobCardDetails$paylo6 !== void 0 && _jobCardDetails$paylo6.TechnicianId)
                });
                data.CustomerComplaints = (_data$CustomerComplai = data.CustomerComplaints) === null || _data$CustomerComplai === void 0 ? void 0 : _data$CustomerComplai.map(function (it) { return _objectSpread({
                    id: it.CustomerVoiceId
                }, it); });
                res = {
                    data: data,
                    success: true,
                    statusCode: 200
                };
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 2:
                _e.sent();
                dispatch(setReducerState({
                    key: loaderKey,
                    value: 'idle'
                }));
                return [2 /*return*/, res];
        }
    });
}); };
var uploadAttachmentUsingId = function (PreJobCardDocumentAttachmentId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var result, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, UploadImage("".concat(Config.baseURL, "resource/JobCardDocumentAttachment/").concat(PreJobCardDocumentAttachmentId), data, "JobCardAccidentalDetail")];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, ""];
            case 3: return [2 /*return*/];
        }
    });
}); };
var uploadAccidentalDetailsImageUpload = function (jobCardId, images, audios) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedImageList, ImageAttachmentsBody, imagesToBeUpload, audioFiles, request, ResponseData, PreJobCardDocumentAttachmentIds, imageAttachmentsWithMediaType1_1, uploadPromises, audioAttachmentsWithMediaType2_1, uploadPromises1, imagePayload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                updatedImageList = [];
                ImageAttachmentsBody = [];
                imagesToBeUpload = [];
                if (images && (images === null || images === void 0 ? void 0 : images.length) > 0) {
                    imagesToBeUpload = images.filter(function (item) { return !item.isAlreadyUploaded; });
                    imagesToBeUpload.map(function (imageItem) {
                        if (!imageItem.isAlreadyUploaded) {
                            ImageAttachmentsBody.push({
                                SystemName: "JobCardAccidentalDetail",
                                MediaType: 1
                            });
                        }
                    });
                }
                audioFiles = [];
                if (audios) {
                    audioFiles = Array.isArray(audios) ? audios : [audios];
                }
                if (audios) {
                    audioFiles.map(function (audioItem) {
                        if (audioItem.file)
                            ImageAttachmentsBody.push({
                                SystemName: "JobCardAccidentalDetail",
                                MediaType: 2
                            });
                    });
                }
                if (!(ImageAttachmentsBody.length > 0)) return [3 /*break*/, 4];
                request = {
                    ParentId: "00000000-0000-0000-0000-000000000000",
                    ImageAttachments: ImageAttachmentsBody
                };
                return [4 /*yield*/, dispatch(createAPI({
                        key: '',
                        url: jobCardAttachmentCreateUrl,
                        request: request
                    }))];
            case 1:
                ResponseData = _a.sent();
                PreJobCardDocumentAttachmentIds = [];
                if (ResponseData.payload.success && ResponseData.payload.data) {
                    PreJobCardDocumentAttachmentIds = ResponseData.payload.data;
                }
                imageAttachmentsWithMediaType1_1 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 1; });
                uploadPromises = imagesToBeUpload.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                    var formData, matchingAttachment, result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!!imageItem.isAlreadyUploaded) return [3 /*break*/, 3];
                                formData = new FormData();
                                formData.append('data', imageItem.file);
                                matchingAttachment = imageAttachmentsWithMediaType1_1[index];
                                if (!matchingAttachment) return [3 /*break*/, 2];
                                return [4 /*yield*/, uploadAttachmentUsingId(matchingAttachment.JobCardDocumentAttachmentId, formData)];
                            case 1:
                                result = _a.sent();
                                if (result.success) {
                                    updatedImageList.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        AttachmentId: result.attachmentId,
                                        MediaType: 1
                                    }));
                                }
                                else {
                                    updatedImageList.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        MediaType: 1
                                    }));
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                // Handle the case where there is no matching attachment with MediaType === 1
                                console.error("No matching attachment found with MediaType === 1");
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                return [4 /*yield*/, Promise.all(uploadPromises)];
            case 2:
                _a.sent();
                audioAttachmentsWithMediaType2_1 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 2; });
                uploadPromises1 = audioFiles.map(function (audioItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                    var formData, matchingAttachment, result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                formData = new FormData();
                                formData.append('data', audioItem.file);
                                matchingAttachment = audioAttachmentsWithMediaType2_1[index];
                                if (!matchingAttachment) return [3 /*break*/, 2];
                                return [4 /*yield*/, uploadAttachmentUsingId(matchingAttachment.JobCardDocumentAttachmentId, formData)];
                            case 1:
                                result = _a.sent();
                                if (result !== null && result !== void 0 && result.success) {
                                    updatedImageList.push(_objectSpread(_objectSpread({}, audioItem), {}, {
                                        AttachmentId: result.attachmentId,
                                        MediaType: 2
                                    }));
                                }
                                else {
                                    updatedImageList.push(_objectSpread(_objectSpread({}, audioItem), {}, {
                                        MediaType: 2
                                    }));
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                // Handle the case where there is no matching attachment with MediaType === 2
                                console.error("No matching attachment found with MediaType === 2");
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                return [4 /*yield*/, Promise.all(uploadPromises1)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                imagePayload = [];
                if (updatedImageList) {
                    updatedImageList.map(function (imageItem) {
                        if (imageItem.AttachmentId) {
                            imagePayload.push({
                                "AttachmentId": imageItem.AttachmentId
                                // "MediaType": imageItem.MediaType,
                                // "SystemName": "JobCardAccidentalDetail",
                            });
                        }
                    });
                }
                return [2 /*return*/, imagePayload];
        }
    });
}); };
export var updateJobCardDetailsApicall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$CustomerComp, _request$AssignedEmpl, _request$FloorSupervi, _request$CampaignId, _request$futureAdvice, _request$InstallBaseI, _request$ParentOrgani, _request$Organization, _request$Registration, _request$VinNo, _request$JobCardId, _request$AssignedEmpl2, _request$CampaignId2, _request$FloorSupervi2, _updateJobCardRespons, _a, key, _b, request, _c, url, updateLoader, upsertPartAndLabourDetailsRequest, upsertCustomerComplaintRequest, upsertJobCardsTechnicianAllocationRequest, upsertAssignToFloorSupervisorRequest, upsertJobCardServiceStationRequest, modifyJobCardRequest, upsertWarrantyRequest, accidentalDetailsImageUploadResponse, accidentalDetailsUpsertBody, autofillJobCardLabourRequest, activeSuggestions, upsertSuggestionsRequest, _i, _d, item, activeFutureAdvices, _e, activeFutureAdvices_1, item, today, selectedDate, UI_SETTINGS, MaxAlloedtoCarryForwordSetting, MaxAllowedToCarryForward, carriedForwardCount, futureAdviceUpsertRequest, promises, getJobCardRequest, updateJobCardResponse, getJobCard;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, dispatch(showLoader({
                    isLoaderOpen: true
                }))];
            case 1:
                _f.sent();
                _a = params.key, key = _a === void 0 ? JobCardKeys.Update : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? '' : _c;
                updateLoader = getLoadingKey(key);
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'loading'
                }));
                upsertPartAndLabourDetailsRequest = {
                    JobCardId: request === null || request === void 0 ? void 0 : request.JobCardId,
                    Parts: request === null || request === void 0 ? void 0 : request.partDetails,
                    Labours: request === null || request === void 0 ? void 0 : request.labourDetails
                };
                upsertCustomerComplaintRequest = {
                    JobCardId: request === null || request === void 0 ? void 0 : request.JobCardId,
                    JobItems: request === null || request === void 0 || (_request$CustomerComp = request.CustomerComplaints) === null || _request$CustomerComp === void 0 ? void 0 : _request$CustomerComp.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        SystemName: "CustomerVoiceToJobItem"
                    }); })
                };
                upsertJobCardsTechnicianAllocationRequest = {
                    JobCardId: request === null || request === void 0 ? void 0 : request.JobCardId,
                    TechnicianId: request.TechnicianId || null
                };
                upsertAssignToFloorSupervisorRequest = {
                    JobCardId: request === null || request === void 0 ? void 0 : request.JobCardId,
                    FloorSupervisorId: request.FloorSupervisorId || null
                };
                upsertJobCardServiceStationRequest = {
                    JobCardId: request === null || request === void 0 ? void 0 : request.JobCardId,
                    ServiceStationId: request.ServiceStationId || null
                };
                modifyJobCardRequest = {
                    AssignedEmployeeId: (_request$AssignedEmpl = request === null || request === void 0 ? void 0 : request.AssignedEmployeeId) !== null && _request$AssignedEmpl !== void 0 ? _request$AssignedEmpl : null,
                    FloorSupervisorId: (_request$FloorSupervi = request === null || request === void 0 ? void 0 : request.FloorSupervisorId) !== null && _request$FloorSupervi !== void 0 ? _request$FloorSupervi : null,
                    CampaignId: (_request$CampaignId = request === null || request === void 0 ? void 0 : request.CampaignId) !== null && _request$CampaignId !== void 0 ? _request$CampaignId : null,
                    IsOdometerChange: request === null || request === void 0 ? void 0 : request.IsOdometerChange,
                    Key: (request === null || request === void 0 ? void 0 : request.Key) !== StatusEnum.Error ? request === null || request === void 0 ? void 0 : request.Key : undefined,
                    ReadyForInvoice: (request === null || request === void 0 ? void 0 : request.ReadyForInvoice) || undefined
                };
                upsertWarrantyRequest = {
                    JobCardId: request === null || request === void 0 ? void 0 : request.JobCardId,
                    WarrantyDetails: request === null || request === void 0 ? void 0 : request.warrantyList
                };
                return [4 /*yield*/, uploadAccidentalDetailsImageUpload(request === null || request === void 0 ? void 0 : request.JobCardId, request.accidentalDetailsPhotographList, request.accidentalDetailsAudioList)];
            case 2:
                accidentalDetailsImageUploadResponse = _f.sent();
                accidentalDetailsUpsertBody = {
                    AccidentDate: request.AccidentDate,
                    AccidentLocation: request.AccidentLocation,
                    OrganizationId: request === null || request === void 0 ? void 0 : request.OrganizationId,
                    ParentOrganizationId: request === null || request === void 0 ? void 0 : request.ParentOrganizationId,
                    JobCardId: request.JobCardId,
                    NatureOfAccidentId: request.NatureOfAccidentId,
                    DamageDescription: request.DamageDescription,
                    AccidentReportNumber: request.AccidentReportNumber,
                    DriverName: request.DriverName,
                    InsuranceProviderId: request.InsuranceProviderId || null,
                    ImageAttachments: accidentalDetailsImageUploadResponse !== null && accidentalDetailsImageUploadResponse !== void 0 ? accidentalDetailsImageUploadResponse : [],
                    PolicyNumber: request.PolicyNumber,
                    PolicyHolderName: request.PolicyHolderName,
                    PolicyExpiryDate: request.PolicyExpiryDate,
                    InsuredName: request.InsuredName,
                    CoverageTypeId: request.CoverageTypeId || null,
                    LossTypeId: request.LossTypeId,
                    IntimatorName: request.IntimatorName,
                    IntimatorNumber: request.IntimatorNumber,
                    IntimationDate: request.IntimationDate
                };
                autofillJobCardLabourRequest = {
                    "JobCardId": request === null || request === void 0 ? void 0 : request.JobCardId,
                    "ProductId": request === null || request === void 0 ? void 0 : request.ProductId,
                    "RepairTypeId": request === null || request === void 0 ? void 0 : request.RepairTypeId
                };
                activeSuggestions = request.suggestions.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                upsertSuggestionsRequest = {
                    SuggestionList: (activeSuggestions === null || activeSuggestions === void 0 ? void 0 : activeSuggestions.map(function (s) { return _objectSpread(_objectSpread({}, s), {}, {
                        SuggestionId: s.SuggestionId || s.id
                    }); })) || [],
                    InstallBaseId: request === null || request === void 0 ? void 0 : request.InstallBaseId,
                    DocumentId: request === null || request === void 0 ? void 0 : request.JobCardId,
                    DocumentType: 'JobCard'
                };
                if (!(request !== null && request !== void 0 && request.suggestions && request.suggestions.length > 0)) return [3 /*break*/, 6];
                _i = 0, _d = request.suggestions;
                _f.label = 3;
            case 3:
                if (!(_i < _d.length)) return [3 /*break*/, 6];
                item = _d[_i];
                if (!(!(item !== null && item !== void 0 && item.IsDeleted) && !item.SuggestionContent)) return [3 /*break*/, 5];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 4:
                _f.sent();
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'idle'
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: t('You’ve added a suggestion line. Please provide the details or remove the line to proceed'),
                    type: 'error'
                }));
                return [2 /*return*/, {
                        success: false
                    }];
            case 5:
                _i++;
                return [3 /*break*/, 3];
            case 6:
                activeFutureAdvices = request.futureAdviceList.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                if (!(request !== null && request !== void 0 && request.futureAdviceList && (request === null || request === void 0 || (_request$futureAdvice = request.futureAdviceList) === null || _request$futureAdvice === void 0 ? void 0 : _request$futureAdvice.length) > 0)) return [3 /*break*/, 20];
                _e = 0, activeFutureAdvices_1 = activeFutureAdvices;
                _f.label = 7;
            case 7:
                if (!(_e < activeFutureAdvices_1.length)) return [3 /*break*/, 18];
                item = activeFutureAdvices_1[_e];
                if (!!item.SuggestionContent) return [3 /*break*/, 9];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 8:
                _f.sent();
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'idle'
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: t("You\u2019ve added a future advice line. Please provide the details or remove the line to proceed."),
                    type: 'error'
                }));
                return [2 /*return*/, {
                        success: false
                    }];
            case 9:
                if (!(item.SuggestionContent && item.SuggestionContent.length > 1000)) return [3 /*break*/, 11];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 10:
                _f.sent();
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'idle'
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: t('Future Advice Details cannot exceed 1000 characters.'),
                    type: 'error'
                }));
                return [2 /*return*/, {
                        success: false
                    }];
            case 11:
                if (!!item.DueDate) return [3 /*break*/, 13];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 12:
                _f.sent();
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'idle'
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: t("Please enter a due date for the all Future Advice."),
                    type: 'error'
                }));
                return [2 /*return*/, {
                        success: false
                    }];
            case 13:
                today = dayjs().startOf('day');
                selectedDate = dayjs(item.DueDate).startOf('day');
                if (!selectedDate.isBefore(today)) return [3 /*break*/, 15];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 14:
                _f.sent();
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'idle'
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: t('Past due date is not allowed. Please select present or future date.'),
                    type: 'error'
                }));
                return [2 /*return*/, {
                        success: false
                    }];
            case 15:
                if (!!item.StatusId) return [3 /*break*/, 17];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 16:
                _f.sent();
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'idle'
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: t('Status is required for all Future Advice.'),
                    type: 'error'
                }));
                return [2 /*return*/, {
                        success: false
                    }];
            case 17:
                _e++;
                return [3 /*break*/, 7];
            case 18:
                UI_SETTINGS = getLocalStorageItem('ByChannelId');
                MaxAlloedtoCarryForwordSetting = UI_SETTINGS === null || UI_SETTINGS === void 0 ? void 0 : UI_SETTINGS.find(function (item) { return item.Key === "FA_Carried_Forward"; });
                MaxAllowedToCarryForward = MaxAlloedtoCarryForwordSetting ? Number(MaxAlloedtoCarryForwordSetting === null || MaxAlloedtoCarryForwordSetting === void 0 ? void 0 : MaxAlloedtoCarryForwordSetting.Value) : null;
                if (!(MaxAllowedToCarryForward !== null)) return [3 /*break*/, 20];
                carriedForwardCount = activeFutureAdvices.filter(function (item) { return item.StatusName === 'Carried forward to next service'; }).length;
                if (!(carriedForwardCount > MaxAllowedToCarryForward)) return [3 /*break*/, 20];
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 19:
                _f.sent();
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'idle'
                }));
                dispatch(showNotification({
                    isOpen: true,
                    message: t("Maximum allowed Future Advice with 'Carried Forward' status (".concat(MaxAllowedToCarryForward, ") has been reached. Please change status to proceed.")),
                    type: 'error'
                }));
                return [2 /*return*/, {
                        success: false
                    }];
            case 20:
                futureAdviceUpsertRequest = {
                    FutureAdviseList: (activeFutureAdvices === null || activeFutureAdvices === void 0 ? void 0 : activeFutureAdvices.map(function (s) {
                        var _s$SuggestionContent, _s$CustomerResponseId, _s$FutureAdviceTypeId, _s$DueDate, _s$StatusId, _s$StatusName;
                        return {
                            FutureAdviceId: s.FutureAdviceId || s.id || null,
                            SuggestionContent: (_s$SuggestionContent = s.SuggestionContent) !== null && _s$SuggestionContent !== void 0 ? _s$SuggestionContent : null,
                            CustomerResponseId: (_s$CustomerResponseId = s.CustomerResponseId) !== null && _s$CustomerResponseId !== void 0 ? _s$CustomerResponseId : null,
                            FutureAdviceTypeId: (_s$FutureAdviceTypeId = s.FutureAdviceTypeId) !== null && _s$FutureAdviceTypeId !== void 0 ? _s$FutureAdviceTypeId : null,
                            DueDate: (_s$DueDate = s.DueDate) !== null && _s$DueDate !== void 0 ? _s$DueDate : null,
                            StatusId: (_s$StatusId = s.StatusId) !== null && _s$StatusId !== void 0 ? _s$StatusId : null,
                            StatusName: (_s$StatusName = s.StatusName) !== null && _s$StatusName !== void 0 ? _s$StatusName : null,
                            IsGlobal: true
                        };
                    })) || [],
                    InstallBaseId: (_request$InstallBaseI = request === null || request === void 0 ? void 0 : request.InstallBaseId) !== null && _request$InstallBaseI !== void 0 ? _request$InstallBaseI : null,
                    ParentOrganizationId: (_request$ParentOrgani = request === null || request === void 0 ? void 0 : request.ParentOrganizationId) !== null && _request$ParentOrgani !== void 0 ? _request$ParentOrgani : null,
                    OrganizationId: (_request$Organization = request === null || request === void 0 ? void 0 : request.OrganizationId) !== null && _request$Organization !== void 0 ? _request$Organization : null,
                    RegistrationNo: (_request$Registration = request === null || request === void 0 ? void 0 : request.RegistrationNo) !== null && _request$Registration !== void 0 ? _request$Registration : null,
                    VinNo: (_request$VinNo = request === null || request === void 0 ? void 0 : request.VinNo) !== null && _request$VinNo !== void 0 ? _request$VinNo : null,
                    DocumentId: (_request$JobCardId = request === null || request === void 0 ? void 0 : request.JobCardId) !== null && _request$JobCardId !== void 0 ? _request$JobCardId : null,
                    DocumentType: 'JobCard'
                };
                promises = [dispatch(createAPI({
                        key: '',
                        url: upsertWarrantyDetailsURL,
                        request: upsertWarrantyRequest
                    })), dispatch(createAPI({
                        key: '',
                        url: upsertCustomerVoiceURL,
                        request: upsertCustomerComplaintRequest
                    })), dispatch(getListAPI({
                        key: '',
                        url: upsertAccidentAndInsuranceDetaisUrl,
                        request: accidentalDetailsUpsertBody
                    })), dispatch(createAPI({
                        key: '',
                        url: upsertSuggestionsURL,
                        request: upsertSuggestionsRequest
                    })), dispatch(createAPI({
                        key: '',
                        url: futureAdviceUpsertURL,
                        request: futureAdviceUpsertRequest
                    }))];
                return [4 /*yield*/, Promise.all(promises)];
            case 21:
                _f.sent();
                return [4 /*yield*/, dispatch(getListAPI({
                        key: 'savedFutureAdvice',
                        url: futureAdviceGetURL,
                        request: {
                            InstallBaseId: request === null || request === void 0 ? void 0 : request.InstallBaseId,
                            DocumentId: request === null || request === void 0 ? void 0 : request.JobCardId,
                            DocumentType: 'JobCard'
                        }
                    }))];
            case 22:
                _f.sent();
                getJobCardRequest = {
                    JobCardId: request === null || request === void 0 ? void 0 : request.JobCardId,
                    TenantId: request === null || request === void 0 ? void 0 : request.OrganizationId
                };
                return [4 /*yield*/, Promise.all([dispatch(createAPI({
                            key: '',
                            url: modifyJobCardURL,
                            request: {
                                ReadyForInvoice: (request === null || request === void 0 ? void 0 : request.ReadyForInvoice) || undefined,
                                JobCardId: request === null || request === void 0 ? void 0 : request.JobCardId,
                                ProductId: request === null || request === void 0 ? void 0 : request.ProductId,
                                RepairTypeId: request === null || request === void 0 ? void 0 : request.RepairTypeId,
                                AssignedEmployeeId: (_request$AssignedEmpl2 = request === null || request === void 0 ? void 0 : request.AssignedEmployeeId) !== null && _request$AssignedEmpl2 !== void 0 ? _request$AssignedEmpl2 : null,
                                CampaignId: (_request$CampaignId2 = request === null || request === void 0 ? void 0 : request.CampaignId) !== null && _request$CampaignId2 !== void 0 ? _request$CampaignId2 : null,
                                FloorSupervisorId: (_request$FloorSupervi2 = request === null || request === void 0 ? void 0 : request.FloorSupervisorId) !== null && _request$FloorSupervi2 !== void 0 ? _request$FloorSupervi2 : null,
                                TechnicianId: (request === null || request === void 0 ? void 0 : request.TechnicianId) || null,
                                ServiceStationId: (request === null || request === void 0 ? void 0 : request.ServiceStationId) || null,
                                Key: request !== null && request !== void 0 && request.ReadyForInvoice ? StatusEnum.ReadyForInvoice : (request === null || request === void 0 ? void 0 : request.Key) !== StatusEnum.Error ? request === null || request === void 0 ? void 0 : request.Key : undefined,
                                Parts: (request === null || request === void 0 ? void 0 : request.partDetails) || [],
                                Labours: (request === null || request === void 0 ? void 0 : request.labourDetails) || []
                            }
                        }))])];
            case 23:
                updateJobCardResponse = (_f.sent())[0];
                return [4 /*yield*/, getAllJobCardDetailsAPICall({
                        key: key,
                        request: getJobCardRequest
                    })];
            case 24:
                getJobCard = _f.sent();
                if (!(updateJobCardResponse !== null && updateJobCardResponse !== void 0 && (_updateJobCardRespons = updateJobCardResponse.payload) !== null && _updateJobCardRespons !== void 0 && _updateJobCardRespons.success)) return [3 /*break*/, 26];
                dispatch(showNotification({
                    isOpen: true,
                    message: t("Saved successfully"),
                    type: "success"
                }));
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 25:
                _f.sent();
                _f.label = 26;
            case 26:
                dispatch(setReducerState({
                    key: updateLoader,
                    value: 'idle'
                }));
                return [2 /*return*/, getJobCard !== null && getJobCard !== void 0 ? getJobCard : {
                        success: false
                    }];
        }
    });
}); };
export var deleteAccidentalDetailsAttachment = function (parentId, attachmentId) { return __awaiter(void 0, void 0, void 0, function () {
    var request, DeleteAttchementResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                request = {
                    SystemName: "JobCardAccidentalDetail",
                    ParentId: parentId,
                    AttachmentId: attachmentId
                };
                return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: deleteAllJobCardAttachmentsUrl,
                        request: request
                    }))];
            case 1:
                DeleteAttchementResponse = _a.sent();
                return [2 /*return*/, DeleteAttchementResponse];
        }
    });
}); };
/***********************warranty details pick list api ******************* */
export var warrantyServiceTypeListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload31, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'warrantyServiceTypeList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? warrantyServiceTypeListURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload31 = res.payload) === null || _res$payload31 === void 0 ? void 0 : _res$payload31.value];
        }
    });
}); };
export var warrantyCasualFlagListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload32, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'casualFlagList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? warrantyCasualFlagListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload32 = res.payload) === null || _res$payload32 === void 0 ? void 0 : _res$payload32.value];
        }
    });
}); };
export var GetOrganizationTypeListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload33, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'getOrganizationTypeList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? GetOrganizationTypeListURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload33 = res.payload) === null || _res$payload33 === void 0 ? void 0 : _res$payload33.value];
        }
    });
}); };
export var warrantyComplaintTypeGetComplaintsAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload34, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'warrantyDefect' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? warrantyComplaintTypeGetComplaintsURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload34 = res.payload) === null || _res$payload34 === void 0 ? void 0 : _res$payload34.value];
        }
    });
}); };
export var warrantyGetPartDetailsAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload35, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'warrantygetPartDetails' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? warrantyGetPartDetailsURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload35 = res.payload) === null || _res$payload35 === void 0 ? void 0 : _res$payload35.value];
        }
    });
}); };
export var LabourListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload36, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'LabourList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? LabourListURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload36 = res.payload) === null || _res$payload36 === void 0 ? void 0 : _res$payload36.value];
        }
    });
}); };
export var pauseReasonListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload37, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'PauseReasonData' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? pauseReasonListAPIUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload37 = res.payload) === null || _res$payload37 === void 0 ? void 0 : _res$payload37.value];
        }
    });
}); };
export var WorkPurchaseOrderListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload38, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'WorkPurchaseOrderList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? WorkPurchaseOrderListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload38 = res.payload) === null || _res$payload38 === void 0 ? void 0 : _res$payload38.value];
        }
    });
}); };
export var getPriceDetailsWithTax = function (rowData, documentDetailsGetById) { return __awaiter(void 0, void 0, void 0, function () {
    var _documentDetailsGetBy, _documentDetailsGetBy2, _documentDetailsGetBy3, _documentDetailsGetBy4, _Response$payload, _Response$payload2, _Response$payload3, requestBody, Response, _Response$payload4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requestBody = {
                    "SystemName": rowData.SystemName,
                    "ItemId": rowData === null || rowData === void 0 ? void 0 : rowData.ChildId,
                    "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                    "VinNo": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.VinNo,
                    "JobCardId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.id,
                    "Quantity": Number(rowData.Quantity),
                    "Entity": 'JobCard',
                    "UnitOfMeasurementId": rowData.UnitOfMeasurementId,
                    "ServiceTypeId": rowData.ServiceTypeId,
                    HSNSACCode: rowData.SavedPriceWithTax.HSNSACCode,
                    CDMSHSNSACCode: rowData.SavedPriceWithTax.CDMSHSNSACCode,
                    // "HSNCode": rowData.HSNCode,
                    // "SACCode": rowData.SACCode,
                    OrganizationStateCode: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.OrganizationStateCode,
                    CustomerStateCode: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.CustomerStateCode,
                    IsTaxExempted: rowData.IsTaxExempted,
                    ChildSystemName: rowData.SystemName === "Parts" ? "Part" : "Labour"
                };
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, dispatch(getListAPI({
                        key: "MRPList",
                        url: getPriceWithTaxUrl,
                        request: requestBody
                    }))];
            case 2:
                Response = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 3:
                _a.sent();
                if (Response !== null && Response !== void 0 && (_Response$payload = Response.payload) !== null && _Response$payload !== void 0 && (_Response$payload = _Response$payload.value) !== null && _Response$payload !== void 0 && _Response$payload.success && Response !== null && Response !== void 0 && (_Response$payload2 = Response.payload) !== null && _Response$payload2 !== void 0 && (_Response$payload2 = _Response$payload2.value) !== null && _Response$payload2 !== void 0 && _Response$payload2.data && (Response === null || Response === void 0 || (_Response$payload3 = Response.payload) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.value) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.data) === null || _Response$payload3 === void 0 ? void 0 : _Response$payload3.length) > 0) {
                    return [2 /*return*/, Response === null || Response === void 0 || (_Response$payload4 = Response.payload) === null || _Response$payload4 === void 0 || (_Response$payload4 = _Response$payload4.value) === null || _Response$payload4 === void 0 ? void 0 : _Response$payload4.data];
                }
                else {
                    return [2 /*return*/, []];
                }
                return [2 /*return*/];
        }
    });
}); };
export var getTax = function (rowData, documentDetailsGetById) { return __awaiter(void 0, void 0, void 0, function () {
    var _documentDetailsGetBy5, _rowData$SavedPriceWi, _documentDetailsGetBy6, _documentDetailsGetBy7, requestBody, Response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requestBody = {
                    // MRP: rowData.MRP,
                    Quantity: rowData.Quantity,
                    IssuedQuantity: rowData.IssuedQuantity,
                    PendingQuantity: rowData.PendingQuantity,
                    CancelQuantity: rowData.CancelQuantity,
                    ReturnedQuantity: rowData.ReturnedQuantity,
                    "Rate": rowData.Rate,
                    DocumentDate: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.CreatedOn,
                    "Entity": 'JobCard',
                    "ServiceTypeId": rowData.ServiceTypeId,
                    "UnitOfMeasurementId": rowData.UnitOfMeasurementId,
                    "PriceMethod": ((_rowData$SavedPriceWi = rowData.SavedPriceWithTax) === null || _rowData$SavedPriceWi === void 0 ? void 0 : _rowData$SavedPriceWi.PriceGroupCategoryKey) || "Sale Price",
                    HSNSACCode: rowData.SavedPriceWithTax.HSNSACCode,
                    CDMSHSNSACCode: rowData.SavedPriceWithTax.CDMSHSNSACCode,
                    // "HSNCode": rowData.HSNCode,
                    // "SACCode": rowData.SACCode,
                    OrganizationStateCode: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.OrganizationStateCode,
                    CustomerStateCode: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy7 = documentDetailsGetById.data) === null || _documentDetailsGetBy7 === void 0 ? void 0 : _documentDetailsGetBy7.CustomerStateCode,
                    IsTaxExempted: rowData.IsTaxExempted,
                    ChildSystemName: rowData.SystemName === "Parts" ? "Part" : "Labour"
                };
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: getTaxUrl,
                        request: requestBody
                    }))];
            case 2:
                Response = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/, Response];
        }
    });
}); };
export var validateQuantityAndGetTax = function (rowData, documentDetailsGetById, installbaseDetailsById) { return __awaiter(void 0, void 0, void 0, function () {
    var _documentDetailsGetBy8, _documentDetailsGetBy9, _documentDetailsGetBy10, _documentDetailsGetBy11, _documentDetailsGetBy12, _installbaseDetailsBy, requestBody, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requestBody = {
                    JobCardId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy8 = documentDetailsGetById.data) === null || _documentDetailsGetBy8 === void 0 ? void 0 : _documentDetailsGetBy8.id,
                    ProductId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy9 = documentDetailsGetById.data) === null || _documentDetailsGetBy9 === void 0 ? void 0 : _documentDetailsGetBy9.ProductId,
                    ChildId: rowData === null || rowData === void 0 ? void 0 : rowData.ChildId,
                    Quantity: rowData.Quantity,
                    IssuedQuantity: rowData.IssuedQuantity,
                    PendingQuantity: rowData.PendingQuantity,
                    CancelQuantity: rowData.CancelQuantity,
                    ReturnedQuantity: rowData.ReturnedQuantity,
                    MRP: rowData.MRP,
                    Rate: rowData.Rate,
                    DocumentDate: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy10 = documentDetailsGetById.data) === null || _documentDetailsGetBy10 === void 0 ? void 0 : _documentDetailsGetBy10.CreatedOn,
                    "Entity": 'JobCard',
                    "ServiceTypeId": rowData.ServiceTypeId,
                    "UnitOfMeasurementId": rowData.UnitOfMeasurementId,
                    "PriceMethod": rowData.PriceGroupCategoryKey || "MRP",
                    HSNSACCode: rowData.SavedPriceWithTax.HSNSACCode,
                    CDMSHSNSACCode: rowData.SavedPriceWithTax.CDMSHSNSACCode,
                    // "HSNCode": rowData.HSNCode,
                    // "SACCode": rowData.SACCode,
                    OrganizationStateCode: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy11 = documentDetailsGetById.data) === null || _documentDetailsGetBy11 === void 0 ? void 0 : _documentDetailsGetBy11.OrganizationStateCode,
                    CustomerStateCode: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy12 = documentDetailsGetById.data) === null || _documentDetailsGetBy12 === void 0 ? void 0 : _documentDetailsGetBy12.CustomerStateCode,
                    IsTaxExempted: rowData.IsTaxExempted,
                    ChildSystemName: rowData.SystemName === "Parts" ? "Part" : "Labour",
                    DateOfMfg: installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy = installbaseDetailsById.data) === null || _installbaseDetailsBy === void 0 ? void 0 : _installbaseDetailsBy.DateOfMfg
                };
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, dispatch(getListAPI({
                        key: JobCardKeys.ValidateQty,
                        url: getJobCardValidateQuantityAndGetTaxUrl,
                        request: requestBody
                    }))];
            case 2:
                res = _a.sent();
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/, res];
        }
    });
}); };
export var validateDeletePartLabour = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _Response$payload5, _a, key, _b, request, _c, url, Response;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, dispatch(showLoader({
                    isLoaderOpen: true
                }))];
            case 1:
                _d.sent();
                _a = params.key, key = _a === void 0 ? "" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ValidateDeletePartLabourUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: url,
                        request: request
                    }))];
            case 2:
                Response = _d.sent();
                // console.log("Response", Response);
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
            case 3:
                // console.log("Response", Response);
                _d.sent();
                return [2 /*return*/, Response === null || Response === void 0 || (_Response$payload5 = Response.payload) === null || _Response$payload5 === void 0 ? void 0 : _Response$payload5.value];
        }
    });
}); };
